const ChangePasswordSuccessModal = ({ onClose }) => {
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3>비밀번호 변경 성공</h3>
        </div>
        <div className="modal-content flex flex-col gap-5">
          <p className="text-b2-400 text-gray-600">비밀번호 변경이 완료되었습니다.</p>
          <p className="text-b2-400 text-gray-600">다시 로그인 해주세요</p>
          <div className="h-8"></div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary big-btn w-full" onClick={onClose}>로그인 페이지로 이동</button>
        </div>
      </div>
    </div>
  )
}

export default ChangePasswordSuccessModal